import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { EXPORTER_APP_OS_DATA } from "@pages/settings/export-workspace/exporter-app-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Renders the buttons to download the Export app */
export function ExporterApp(t0) {
  const $ = _c(9);
  const {
    direction
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== trackEvent) {
    t1 = function trackDownloadEvent(system) {
      trackEvent({
        name: WorkspaceEvents.downloadExporterApp,
        props: {
          system
        }
      });
    };
    $[0] = trackEvent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trackDownloadEvent = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "flex-end"
    };
    t3 = Object.values(EXPORTER_APP_OS_DATA);
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== trackDownloadEvent) {
    t4 = t3.map(osData => <Link key={osData.system} href={osData.downloadUrl} download={true} target="_blank" rel="noopener noreferrer"><Button variant="secondary" icon={osData.icon} onClick={() => trackDownloadEvent(osData.system)}>{osData.name}</Button></Link>);
    $[4] = trackDownloadEvent;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== direction || $[7] !== t4) {
    t5 = <Stack direction={direction} spacing={2} sx={t2}>{t4}</Stack>;
    $[6] = direction;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}